import { matchPath, useLocation, useSearchParams } from "react-router-dom"

import { REDIRECT_URL_PARAM_AUTH } from "@/const/provider-auth.constants"
import { NAMES_ROUTES } from "@/const/routes.constants"

export const useKeyByParams = () => {
  const [searchParams] = useSearchParams()
  const { pathname } = useLocation()
  const redirectUrl = searchParams.get(REDIRECT_URL_PARAM_AUTH)
  const pathnameMatch = redirectUrl ? redirectUrl.split("?")[0] : pathname

  const { first = "" } =
    matchPath({ path: "/:first", end: false }, pathnameMatch)?.params || {}
  let { second = "" } =
    matchPath({ path: `${first}/:second`, end: false }, pathnameMatch)
      ?.params || {}

  if (first === NAMES_ROUTES.REPORTS.ROOT) second = ""

  return !first && !second ? "/" : `/${first}${second ? `/${second}` : ""}`
}
